import React, {Component} from 'react'
import PrintPreview from './PrintPreview'
import PdfStore from 'stores/PdfStore'
import { Checkbox } from 'react-icheck'
import WorkdocStore from 'stores/WorkdocStore'
// import SignatureModal from 'component/element/SignatureModal'
const NotificationSystem = require('react-notification-system');
const DOC = {doc0:false,doc1:false}
const ITEMDOC = {
  related_detail:{
    doc:DOC
  }
}
class PrintDeliveryCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      report_title:'กำลังดึงข้อมูล..',
      data:{
        related_detail:{
          doc:DOC
        },
        receiving:{},
        car:{},
        delivering:{},
        driver:{},
        insurer:{},
        owner:{}
      },
      // signature:{p0:null,p1:null},
      // sigKey:null
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  loadData() {
    let {workNo,dn} = this.props
    PdfStore.loadDelivercarDoc(workNo,'delivery_doc',(result)=> {
      let data = result.data
      data.related_detail = Object.assign(ITEMDOC.related_detail,data.related_detail)
      this.setState({data:data,report_title:'ไม่พบข้อมูล'})
    })  
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value*1
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  // onLoadSignature(field) {
  //   let {signature} = this.state
  //   this.setState({sigKey:field})
  //   let action = 'del'
  //   if (signature[field]===null)
  //     action = 'add'
  //   this.refs.signatureModal.onSentSignatureConfirm(action)
  // }

  // onSentSignature(item) {
  //   let {signature,sigKey} = this.state
  //   signature[sigKey] = item.signature_data_url
  //   this.setState({signature:signature,sigKey:null})
  // }

  onDocChange(val,field) {
    let {data} = this.state
    data.related_detail.doc[field] = val
    this.setState({data:data},()=>{
      this.saveWorkdocRelated()
    })
  }

  saveWorkdocRelated() {
    let {workNo} = this.props
    let {data} = this.state
    WorkdocStore.saveWorkdocRelated(workNo,'delivery_doc',data.related_detail,(result) => {
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
            level: 'info',
            position: 'tc',        
        })
    },(result) => {
        this._notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
            level: 'error',
            position: 'tc'
        })
    })    
  }

  renderBody() {
    let {data} = this.state
    const title = this.props.title
    const {workNo} = this.props 
    return(
      <div>
        <div className='text-center'><h3 style={{margin:'0',fontWeight:'bold',textDecoration:'underline'}}>{title}</h3></div>
        <table className='table table-print-delivery-car-doc' style={{marginBottom:'0'}}>
          <tbody>
            <tr>
              <td style={{width:'300px'}} className='text-left'>เลขที่ใบงาน : {workNo}</td>
              <td style={{width:'200px'}}></td>
              <td style={{width:'300px'}} className='text-left'>เลขที่อ้างอิง : {data.receiving?data.receiving.ref_no:''}</td>
              <td style={{width:'200px'}}></td>
            </tr>
            <tr>
              <td className='text-left'>ทะเบียนรถ : {data.car?data.car.car_registration_no:''}</td>
              <td className='text-left'></td>
              <td colSpan={2} className='text-left'>ยี่ห้อรถ : {data.car?data.car.brand:''}</td>
            </tr>
            <tr>
              <td className='text-left'>รุ่นรถ : {data.car?data.car.model:''}</td>
              <td className='text-left'></td>
              <td colSpan={2} className='text-left'>แบบ : {data.car?data.car.series:''}</td>
            </tr>
            <tr>
              <td className='text-left'>บ. ประกันภัย : {data.insurer_name}</td>
              <td className='text-left'></td>
              <td colSpan={2} className='text-left'>เลขที่กรมธรรม์ : {data.insurer?data.insurer.insurance_policy_no:''}</td>
            </tr>
            <tr>
              <td className='text-left'>เลขที่เคลม : {data.insurer?data.insurer.claim_no:''}</td>
              <td className='text-left'></td>
              <td colSpan={2} className='text-left'>เลขที่ใบแจ้ง : {data.insurer?data.insurer.inform_no:''}</td>
            </tr>
            <tr>
              <td className='text-left'>ค่าเพิ่มเติม : {data.car?data.car.sum_excess:''}</td>
              <td className='text-left'>ค่าเงื่อนไข : </td>
              <td colSpan={2} className='text-left'>รวมเป็นเงิน : {this.getNumberFormat(data.amount)}</td>
            </tr>
          </tbody>
        </table>
        <table className='table table-print-delivery-car-doc' style={{marginBottom:'0'}}>
          <tbody>
            <tr>
              <td colSpan={4} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td colSpan={4} style={{fontWeight:'bold',textDecoration:'underline'}} className='text-left'>
                รายละเอียดการติดต่อเข้าซ่อม
              </td>
            </tr>
            <tr>
              <td style={{width:'300px'}} className='text-left'>วันที่ติดต่อเข้าซ่อม : {data.receiving?data.receiving.contact_date:''}</td>
              <td style={{width:'200px'}} className='text-left'>เวลา : {data.receiving?data.receiving.contact_time:''}</td>
              <td style={{width:'300px'}} className='text-left'>วันที่นัดรับรถเข้าซ่อมล่วงหน้า : {data.receiving?data.receiving.entrance_date:''}</td>
              <td style={{width:'200px'}} className='text-left'>เวลา : {data.receiving?data.receiving.entrance_time:''}</td>
            </tr>
            <tr>
              <td colSpan={2} className='text-left'>ผู้ติดต่อเข้าซ่อม : {data.receiving?data.receiving.entrance_name:''}</td>
              <td colSpan={2} className='text-left'>โทร : {data.receiving?data.receiving.tel:''}</td>
            </tr>
            <tr>
              <td colSpan={4} className='text-left'>เจ้าหน้าที่ศูนย์/อู่ : {data.receiving?data.receiving.receiving_by:''}</td>
            </tr>
          </tbody>
        </table>
        <table className='table table-print-delivery-car-doc' style={{marginBottom:'0'}}>    
          <tbody>
            <tr>
              <td style={{width:'100px'}} className='text-left'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center'>{data.receiving?data.receiving.receiving_by:''}</td>
              <td style={{width:'150px'}} className='text-left'>เจ้าหน้าที่ศูนย์/อู่</td>
              <td style={{width:'100px'}} className='text-left'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center'>{data.receiving?data.receiving.entrance_name:''}</td>
              <td style={{width:'150px'}} className='text-left'>ผู้ติดต่อเข้าซ่อม</td>
            </tr>
            <tr>
              <td colSpan={6} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td className='text-left'></td>
              <td className='text-center'>(......................................)</td>
              <td className='text-left'></td>
              <td className='text-left'></td>
              <td className='text-center'>(......................................)</td>
              <td className='text-left'></td>
            </tr>
          </tbody>
        </table>  
        <table className='table table-print-delivery-car-doc' style={{marginBottom:'0'}}>
          <tbody>
            <tr>
              <td colSpan={4} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td colSpan={4} style={{fontWeight:'bold',textDecoration:'underline'}} className='text-left'>
                รายละเอียดการรับรถเข้าซ่อม
              </td>
            </tr>
            <tr>
              <td style={{width:'300px'}} className='text-left'>วันที่นำรถเข้าซ่อม : {data.receiving?data.receiving.advance_date:''}</td>
              <td style={{width:'200px'}} className='text-left'>เวลา : </td>
              <td style={{width:'300px'}} className='text-left'>วันที่นัดรับรถ : {data.receiving?data.receiving.appointment_date:''}</td>
              <td style={{width:'200px'}} className='text-left'>เวลา : {data.receiving?data.receiving.appointment_time:''}</td>
            </tr>
            <tr>
              <td colSpan={2} className='text-left'>ผู้นำรถเข้าซ่อม : {data.owner?data.owner.name:''}</td>
              <td colSpan={2} className='text-left'>เลขประจำตัวประชาชน : {data.owner?data.owner.identity_no:''}</td>
            </tr>
            <tr>
              <td colSpan={4} className='text-left'>สถานที่ติดต่อ : {data.owner?data.owner.address:''}</td>
            </tr>
            <tr>
              <td colSpan={4} className='text-left'>โทร : {data.owner?data.owner.tel:''}</td>
            </tr>
            <tr>
              <td colSpan={2} className='text-left'>หมายเลข กม. : {data.car?data.car.mileage:''}</td>
              <td colSpan={2} className='text-left'>ระดับน้ำมันเชื้อเพลิง : </td>
            </tr>
            <tr>
              <td colSpan={4} className='text-left'>อุปกรณ์ทรัพย์สินภายในรถ : </td>
            </tr>
            <tr>
              <td colSpan={4} className='text-left'>ความเสียหายอื่นๆไม่รวมการซ่อม : </td>
            </tr>
            <tr>
              <td colSpan={4} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td colSpan={4} className='text-center text-red'>โปรดนำสิ่งของมีค่า ออกจากรถ หากเสียหาย/สูญหาย จะไม่รับผิดชอบ</td>
            </tr>
            <tr>
              <td colSpan={4} className='text-left'>
                <br />
              </td>
            </tr>
          </tbody>
        </table>
        <table className='table table-print-delivery-car-doc' style={{marginBottom:'0'}}>    
          <tbody>
            <tr>
              <td style={{width:'100px'}} className='text-left'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center'>{data.receiving?data.receiving.receiving_by:''}</td>
              <td style={{width:'150px'}} className='text-left'>เจ้าหน้าที่รับรถเข้าซ่อม</td>
              <td style={{width:'100px'}} className='text-left'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center'>{data.owner?data.owner.name:''}</td>
              <td style={{width:'150px'}} className='text-left'>ผู้นำรถเข้าซ่อม</td>
            </tr>
            <tr>
              <td colSpan={6} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td className='text-left'></td>
              <td className='text-center'>(......................................)</td>
              <td className='text-left'></td>
              <td className='text-left'></td>
              <td className='text-center'>(......................................)</td>
              <td className='text-left'></td>
            </tr>
          </tbody>
        </table>
        <table className='table table-print-delivery-car-doc' style={{marginBottom:'0'}}>
          <tbody>
            <tr>
              <td colSpan={3} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td colSpan={3} className='text-left'>
                เอกสารที่ต้องนำมาในใบรับรถ :
                &nbsp;
                <Checkbox
                  onChange={this.onDocChange.bind(this,(data.related_detail.doc.doc0?false:true),'doc0')}
                  checked={data.related_detail.doc.doc0}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' เอกสารใบรับรถเข้าซ่อม'}
                >
                </Checkbox>
                &nbsp;
                <Checkbox
                  onChange={this.onDocChange.bind(this,(data.related_detail.doc.doc1?false:true),'doc1')}
                  checked={data.related_detail.doc.doc1}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' สําเนาบัตรประจำตัวประชาชน'}
                >
                </Checkbox>
              </td>
            </tr>
            <tr>
              <td colSpan={8} style={{fontWeight:'bold',textDecoration:'underline'}} className='text-left'>
                รายละเอียดการส่งมอบรถ
              </td>
            </tr>
            <tr>
              <td style={{width:'300px'}} className='text-left'>วันที่ลูกค้ามารับรถ : {data.delivering?data.delivering.delivering_date:''}</td>
              <td style={{width:'200px'}} className='text-left'>เวลา : {data.delivering?data.delivering.delivering_time:''}</td>
              <td style={{width:'300px'}} className='text-left'>เลขประจำตัวประชาชน : {data.delivering?data.delivering.identity_no:''}</td>
              <td style={{width:'200px'}} className='text-left'></td>
            </tr>
            <tr>
              <td colSpan={2} className='text-left'>ผู้มารับรถ : {data.delivering?data.delivering.name:''}</td>
              <td colSpan={2} className='text-left'>เกี่ยวข้องกับผู้เอาประกัน : </td>
            </tr>
            <tr>
              <td colSpan={2} className='text-left'>โทร : {data.delivering?data.delivering.tel:''}</td>
              <td colSpan={2} className='text-left'>ผลการซ่อม : </td>
            </tr>
          </tbody>
        </table>    
        <table className='table table-print-delivery-car-doc' style={{marginBottom:'0'}}>    
          <tbody>
            <tr>
              <td style={{width:'100px'}} className='text-left'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center'>{data.delivering?data.delivering.delivering_name:''}</td>
              <td style={{width:'150px'}} className='text-left'>เจ้าหน้าที่ส่งมอบรถ</td>
              <td style={{width:'100px'}} className='text-left'>ลงชื่อ</td>
              <td style={{width:'150px'}} className='text-center'>{data.receiving?data.receiving.receiving_by:''}</td>
              <td style={{width:'150px'}} className='text-left'>ผู้รับส่งมอบรถ</td>
            </tr>
            <tr>
              <td colSpan={6} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td className='text-left'></td>
              <td className='text-center'>(......................................)</td>
              <td className='text-left'></td>
              <td className='text-left'></td>
              <td className='text-center'>(......................................)</td>
              <td className='text-left'></td>
            </tr>
            <tr>
              <td colSpan={6} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td colSpan={6} className='text-center'>
                ข้าพเจ้าได้ตรวจสอบการส่งมอบรถเรียบร้อยแล้ว
              </td>
            </tr>
            <tr>
              <td colSpan={6} className='text-left'>
                <br />
              </td>
            </tr>
            <tr>
              <td colSpan={6} className='text-center text-red'>
                กรณีซ่อมรถไม่เรียบร้อยหรือสภาพอุปกรณ์ไม่ถูกต้องโปรดแจ้งเจ้าหน้าที่
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

  renderComponentPage() {
    let {data} = this.state
    const title = this.props.title
    return(
      <div>
        <div className='font-print'>
          <div>
            <header>
              <h2>{title}</h2>
            </header>
            <article className={"article-company "+data.logo_class}>
              <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
                {this.renderLogoUrl(data.logo_url)}
              </div>
              <section className="font-18" style={{paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
              <strong>
                <p style={{lineHeight:'0.7'}}>{data.company_name} ({data.company_branch})</p>
                <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
                <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>
              </strong>
            </section>
            </article>
          </div>
          <div>
            {this.renderBody()}
          </div>
        </div>  
        {/* <SignatureModal
          ref='signatureModal'
          mode='print'
          onSentSignature={this.onSentSignature.bind(this)}
        /> */}
      </div>  
    )
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {this.renderComponentPage()}
        </PrintPreview>
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )  
  }
}  

PrintDeliveryCarDoc.defaultProps = {
  title: 'ใบส่งมอบรถ'
}
export default PrintDeliveryCarDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintDeliveryCarDoc.js